export default __webpack_public_path__ + "static/media/loading.b16d77b0.svg";